export const constants = {


    SET_ROOMS: 'SET_ROOMS',
    




};

export default constants;
